@use "/src/styles/functions.scss";
@use "/src/styles/mixins.scss";

.row {
  width: 100%;
  display: flex;
  gap: functions.toRem(8) functions.toRem(24);
  flex-wrap: wrap;
}

.row-input {
  width: 100%;
  max-width: functions.toRem(400);

  @include mixins.respond(xs) {
    max-width: unset;
    min-width: 100%;
  }
}

.row-field {
  width: functions.toRem(500);

  @include mixins.respond(xs) {
    width: 100%;
  }
}
